<template>
  <div>
    <v-dialog v-model="confirmation_dialog" width="30vw">
      <v-card color="universal-vcard">
        <div class="universal-vdialog-title">
          {{message}}
        </div>
        <div class="vdialog-buttons-wrapper">
          <div
            class="universal-vdialog-button vbutton-secondary"
            @click="cancelAction"
          >
            {{ $t("repetitive.cancel") }}
          </div>
          <div
            class="universal-vdialog-button vbutton-primary"
            @click="confirmAction"
          >
            {{ $t("repetitive.okay") }}
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
    props:{
        message : {
            type : String,
            default : ""
        },

    },
  data() {
    return {
      confirmation_dialog: false,
    };
  },
  methods: {
    openDialog() {
      this.confirmation_dialog = true;
    },

    confirmAction() {
      this.$emit("confirm");
      this.cancelAction()
    },

    cancelAction() {
      this.confirmation_dialog = false;
    },
  },
};
</script>

<style></style>
